<div class="treeContainer">
  <p-tree
    #tree
    [draggableNodes]="true"
    [droppableNodes]="true"
    [loading]="loading"
    [style]="{ overflow: 'auto', 'max-height': maxTreeHeight }"
    [value]="treeData?.treeNodes"
    (onNodeDrop)="onNodeDrop($event)"
    (onNodeSelect)="nodeSelect($event)" />
</div>
